import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { IAgentFormState } from '../types';

const initialState: IAgentFormState = {
  iin: '',
  fullName: '',
  status: '',
  phone: '',
  email: '',
  experience: '',
  region: '',
};

const agentFormSlice = createSlice({
  name: 'agentForm',
  initialState,
  reducers: {
    resetAgentForm: () => initialState,

    addAgentFormData: (
      state: Draft<IAgentFormState>,
      action: PayloadAction<{
        iin: string;
        fullName: string;
        status: string;
        phone: string;
        email: string;
        experience: string;
        region: string;
      }>
    ) => {
      state.iin = action.payload.iin;
      state.fullName = action.payload.fullName;
      state.status = action.payload.status;
      state.phone = action.payload.phone;
      state.email = action.payload.email;
      state.experience = action.payload.experience;
      state.region = action.payload.region;
    },
  },
});

export const { resetAgentForm, addAgentFormData } = agentFormSlice.actions;
export default agentFormSlice.reducer;
